import { postWithoutTOken } from "./apiUtils";
import { notificationService } from "./../notificationService";
import * as keys from "../../utils/constant";
import * as storage from "../storage";
import * as constant from "../../utils/constant";
import { LogEntity, UserAction } from '../../utils/constant';

export const logout = async () => {

  try {
    const profile = storage.getLocalStorage(constant.STORAGE_PROFILE_KEY);
    await saveUserActivity(`User Logout : ${profile?.name}`);
  } catch (error) {
    console.error('Failed to save logout activity', error);
  }
  storage.deleteLocalStorage(constant.STORAGE_PROFILE_KEY);
  storage.deleteLocalStorage("pageName");
  storage.deleteLocalStorage(keys.COMMON_SERVICE_AUTH_TOKEN);
  storage.deleteLocalStorage(keys.STORAGE_TOKEN_KEY);
  storage.deleteLocalStorage(keys.CLIENT_DATA);
};

export const login = async (data) => {
  const headers = {Env: process.env.REACT_APP_ENV};
  return await postWithoutTOken(
    process.env.REACT_APP_API_URL + "User/Login/",
    "",
    data,
    false,
    headers,
    false
  )
    .then((response) => {
      const token = response.receiveObj.data.data.token;
      const user = response.receiveObj.data.data;
      const commonServiceToken =
        response.receiveObj.data.data?.commonServiceToken;
      if (response.success && token && user) {
        storage.setLocalStorage(keys.STORAGE_TOKEN_KEY, token);
        storage.setLocalStorage(
          keys.COMMON_SERVICE_AUTH_TOKEN,
          commonServiceToken
        );
        storage.setLocalStorage(keys.STORAGE_PROFILE_KEY, user);
        return {
          isAuthenticated: true,
          token: token,
          profile: user,
          commonServiceToken: commonServiceToken,
        };
      }
    })
    .catch((error) => {
      storage.deleteLocalStorage(keys.COMMON_SERVICE_AUTH_TOKEN);
      storage.deleteLocalStorage(keys.STORAGE_TOKEN_KEY);
      storage.deleteLocalStorage(keys.STORAGE_PROFILE_KEY);
      const errorsArray = error?.receiveObj?.response?.data?.errors;
      if (errorsArray !== null && errorsArray?.Name) {
        notificationService.sendErrorMessage(errorsArray.Name[0]);
      } else if (errorsArray !== null && errorsArray?.Password) {
        notificationService.sendErrorMessage(errorsArray.Password[0]);
      } else {
        const errorMessage = error?.receiveObj?.response?.data?.message;
        if (errorMessage) {
          notificationService.sendErrorMessage(errorMessage);
        }
      }
      return error;
    });
};

export const redirectedLogin = async (data) => {
  const headers = {Env: process.env.REACT_APP_ENV};
  return await postWithoutTOken(
    process.env.REACT_APP_API_URL + "User/GetUserProfile/",
    "",
    data,
    false,
    headers,
    false
  )
    .then((response) => {
      const token = response.receiveObj.data.data.token;
      const user = response.receiveObj.data.data;
      const commonServiceToken =
        response.receiveObj.data.data?.commonServiceToken;
      if (response.success && token && user) {
        storage.setLocalStorage(keys.STORAGE_TOKEN_KEY, token);
        storage.setLocalStorage(
          keys.COMMON_SERVICE_AUTH_TOKEN,
          commonServiceToken
        );
        storage.setLocalStorage(keys.STORAGE_PROFILE_KEY, user);
        return {
          isAuthenticated: true,
          token: token,
          profile: user,
          commonServiceToken: commonServiceToken,
        };
      }
      return response;
    })
    .catch((error) => {
      storage.deleteLocalStorage(keys.COMMON_SERVICE_AUTH_TOKEN);
      storage.deleteLocalStorage(keys.STORAGE_TOKEN_KEY);
      storage.deleteLocalStorage(keys.STORAGE_PROFILE_KEY);
      const errorsArray = error?.receiveObj?.response?.data?.errors;
      if (errorsArray !== null && errorsArray?.Name) {
        notificationService.sendErrorMessage(errorsArray.Name[0]);
      } else if (errorsArray !== null && errorsArray?.Password) {
        notificationService.sendErrorMessage(errorsArray.Password[0]);
      } else {
        const errorMessage = error?.receiveObj?.response?.data?.message;
        if (errorMessage) {
          notificationService.sendErrorMessage(errorMessage);
        }
      }
      return error;
    });
};


export const saveUserActivity = (dataToSend) => {

    // console.log(dataToSend)
    const profile = storage.getLocalStorage(constant.STORAGE_PROFILE_KEY);
    // console.log(profile)
    // return
    const payload = {
      partitionKey: profile?.userId,
      entityType: LogEntity.USER,
      activity: dataToSend,
      companyId: profile?.user?.companyId,
      domain: window.location.origin,
      source: "PROVIDER-PORTAL",
      userId: profile?.userId,
      userName: profile?.name
    };

       const token = storage.getLocalStorage(constant.STORAGE_TOKEN_KEY);
        const AccessToken = token?.token;

    fetch(process.env.REACT_APP_API_URL+'User/SaveUserActivity', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${AccessToken}` // if needed
      },
      body: JSON.stringify(payload)
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to save user activity');
        }
        return response.json();
      })
      .then(data => {
        console.log('User activity saved successfully:', data);
      })
      .catch(error => {
        console.error('Error saving user activity:', error);
      });
  };